import { create } from 'zustand';
import { DatasetStore, IDatasetBrief } from '../types/metadata';

const useDatasetStore = create<DatasetStore>((set, get) => ({
  datasetBriefs: [],
  fweDatasetBriefs: [],

  setDatasetBrief: (datasets: IDatasetBrief[]) =>
    set({ datasetBriefs: datasets }),
  setFWEDatasetBrief: (datasets: IDatasetBrief[]) =>
    set({ fweDatasetBriefs: datasets }),

  metadatas: [],
  setMetadatas: (metadatas) => set({ metadatas }),
  addMetadatas: (newMetadata) =>
    set((state) => {
      return { metadatas: [...state.metadatas, newMetadata] };
    }),

  getFWEDatasetIds: () => {
    const state = get();
    return state.fweDatasetBriefs.map((d) => d.id);
  },

  getAllDatasetIds: () => {
    const state = get();
    const moodBriefs = state.datasetBriefs.filter((d) => d.isFWE === false);
    return moodBriefs.map((d) => d.id);
  },
}));

export default useDatasetStore;
